<script setup>
import { defineEmits, defineProps } from "vue";

const emit = defineEmits(["click"]);
const props = defineProps({
  label: String,
  notLink: Boolean,
});

function onClick() {
  emit("click");
}
</script>

<template>
  <div
    v-if="!props.notLink"
    @click="onClick"
    class="text-primary text-medium-emphasis pointer"
  >
    {{ props.label }}
  </div>
  <div v-else class="text-medium-emphasis">
    {{ props.label }}
  </div>
</template>
